<style scoped>
.embed-container {
  overflow: hidden;
  padding: 0px !important;
}
</style>

<template>
  <div v-if="flagFetchedMedia" class="embed-container">
    <MediaContentPanel
      :media="media"
      :flagReactionDetailShow="flagReactionDetailShow"
      @onUpdateTime="onUpdateTime"
      :flagPauseSwitch="flagPauseSwitch"
      :timestamp="timestamp"
      :flagPlaylistShow="false"
      :overlays="overlays"
      :isAdmin="false"
      />
    <media-bar
      :mediaId="mediaIdNow"
      :currentTime="currentTime"
      :type="media.type"
      :media="media"
      :isAdmin="false"
      @onChangeModelReactionDetailPanel="onChangeModelReactionDetailPanel" />
  </div>
</template>

<script>

// Components
import MediaContentPanel from '@/components/Media/MediaContentPanel.vue'
import MediaBar from '@/components/Media/MediaBar.vue'

// Library
import axios from "axios";

export default {
  name: 'EmbedMedia',
  components: {
    MediaContentPanel,
    MediaBar
  },
  props: {
    mediaId: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {

      loading: null,

      // Object
      mediaIdNow: this.mediaId,
      media: {}, // Media object
      comments: [], // Comment list
      overlays: [],

      // Flag
      flagFetchedMedia: false, // Boolean variable for status of media fetched
      flagPauseSwitch: false, // Flag for indicating pause on video due to comment adding
      flagFetchedOverlays: false, // Boolean variable for status of overlay fetched
      flagReactionDetailShow: false,

      // Video
      currentTime: 0, // Current time of video
      timestamp: 0 // Timestamp variable for storing new timestamp
    }
  },
  computed: {
    // String
    stringPath: function() {
      return "/media/" + this.mediaId;
    },
  },
  watch: {
    mediaId: function() {

      this.checkPermit();
    },
  },
  created() {

    this.checkPermit();
  },
  methods: {
    // Fetch
    checkPermit: function() {
      axios.get(this.$store.getters.urlApi + "permit/media/" + this.mediaIdNow, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        var result = response.data.data.result;
        if(result) {
          this.fetchMedia();
          this.fetchOverlays();
        } else {

        }
      });
    },
    fetchMedia: function() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaIdNow, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.media = response.data.data.media
        this.flagFetchedMedia = true;

      });
    },
    fetchOverlays: function() {
      axios.get(this.$store.getters.urlApi + "overlay/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.overlays = response.data.data.overlays;
        this.flagFetchedOverlays = true;
      });
    },

    // Event
    onUpdateTime: function(timeNew) {
      this.currentTime = timeNew;
    },
    onFocusInput: function() {
      this.flagPauseSwitch = true;
    },
    onFocusOutInput: function() {
      this.flagPauseSwitch = false;
    },
    onClickTimestamp: function(time) {
      this.timestamp = time;
    },
    onChangeModelReactionDetailPanel(payload) {
      this.flagReactionDetailShow = payload;
    },
  },
}
</script>
